import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User viewed favorites',
  name: 'viewed_favorites',
  params: [],
};

export default META;
